const CHATBOT_EMBED_KEY = "9eea502502cb01108f611eb965b6d3449603d958a95c340229125a4d0d8e7dba";
const CHATBOT_EMBED_ID = 3148;

export const CHATBOT_SCRIPT_SRC = `https://static.inteliwise.com/embed/${ CHATBOT_EMBED_KEY }/${ CHATBOT_EMBED_ID }/space.js`;

// Prefix of the entries the chatbot widget keeps in localStorage and sessionStorage
export const CHATBOT_STORAGE_PREFIXES = [ `${ CHATBOT_EMBED_KEY }-${ CHATBOT_EMBED_ID }-iw-` ];
